// extracted by mini-css-extract-plugin
export var errorIcon = "_k7-1";
export var nameLogo = "_k7-0";